/**
 * Catalogo de perfis e permissoes, espelhando o seed do backend em
 * db/migration/master/V2__seed_rbac.sql. Alterar aqui obriga a alterar la.
 *
 * Convencao: <accao>:<recurso>
 */
export enum Roles {
  SA = 'SA',
  ADMIN = 'ADMIN',
  DIRECTION = 'DIRECTION',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
  COMMERCIAL_MANAGER = 'COMMERCIAL_MANAGER',
  EVENTS_MANAGER = 'EVENTS_MANAGER',
  TRANSPORT_MANAGER = 'TRANSPORT_MANAGER',
  STOCK_MANAGER = 'STOCK_MANAGER',
  OPERATIONS = 'OPERATIONS',
  VIEWER = 'VIEWER',
}

export const RESOURCES = [
  'dashboard',
  'clients',
  'suppliers',
  'quotations',
  'contracts',
  'services',
  'orders',
  'deliveries',
  'incomes',
  'expenses',
  'events',
  'vehicles',
  'drivers',
  'routes',
  'trips',
  'maintenances',
  'products',
  'stock-movements',
  'tasks',
  'documents',
  'reports',
  'users',
  'roles',
  'permissions',
  'settings',
  'audit',
  'companies',
] as const;

export type Resource = (typeof RESOURCES)[number];
export type Action = 'read' | 'create' | 'update' | 'delete' | 'export';

/** Constroi o nome da permissao, ex.: can('create', 'quotations') -> 'create:quotations' */
export const can = (action: Action, resource: Resource): string => `${action}:${resource}`;

export enum Authorities {
  // Painel
  READ_DASHBOARD = 'read:dashboard',

  // Comercial
  READ_CLIENTS = 'read:clients',
  CREATE_CLIENTS = 'create:clients',
  UPDATE_CLIENTS = 'update:clients',
  DELETE_CLIENTS = 'delete:clients',
  EXPORT_CLIENTS = 'export:clients',

  READ_SUPPLIERS = 'read:suppliers',
  CREATE_SUPPLIERS = 'create:suppliers',
  UPDATE_SUPPLIERS = 'update:suppliers',
  DELETE_SUPPLIERS = 'delete:suppliers',
  EXPORT_SUPPLIERS = 'export:suppliers',

  READ_QUOTATIONS = 'read:quotations',
  CREATE_QUOTATIONS = 'create:quotations',
  UPDATE_QUOTATIONS = 'update:quotations',
  DELETE_QUOTATIONS = 'delete:quotations',
  EXPORT_QUOTATIONS = 'export:quotations',
  APPROVE_QUOTATIONS = 'approve:quotations',

  READ_CONTRACTS = 'read:contracts',
  CREATE_CONTRACTS = 'create:contracts',
  UPDATE_CONTRACTS = 'update:contracts',
  DELETE_CONTRACTS = 'delete:contracts',
  EXPORT_CONTRACTS = 'export:contracts',
  APPROVE_CONTRACTS = 'approve:contracts',

  READ_SERVICES = 'read:services',
  CREATE_SERVICES = 'create:services',
  UPDATE_SERVICES = 'update:services',
  DELETE_SERVICES = 'delete:services',

  // Operacoes
  READ_ORDERS = 'read:orders',
  CREATE_ORDERS = 'create:orders',
  UPDATE_ORDERS = 'update:orders',
  DELETE_ORDERS = 'delete:orders',

  READ_DELIVERIES = 'read:deliveries',
  CREATE_DELIVERIES = 'create:deliveries',
  UPDATE_DELIVERIES = 'update:deliveries',
  DELETE_DELIVERIES = 'delete:deliveries',

  READ_TASKS = 'read:tasks',
  CREATE_TASKS = 'create:tasks',
  UPDATE_TASKS = 'update:tasks',
  DELETE_TASKS = 'delete:tasks',

  // Financeiro
  READ_INCOMES = 'read:incomes',
  CREATE_INCOMES = 'create:incomes',
  UPDATE_INCOMES = 'update:incomes',
  DELETE_INCOMES = 'delete:incomes',
  EXPORT_INCOMES = 'export:incomes',

  READ_EXPENSES = 'read:expenses',
  CREATE_EXPENSES = 'create:expenses',
  UPDATE_EXPENSES = 'update:expenses',
  DELETE_EXPENSES = 'delete:expenses',
  EXPORT_EXPENSES = 'export:expenses',
  APPROVE_EXPENSES = 'approve:expenses',

  // Eventos
  READ_EVENTS = 'read:events',
  CREATE_EVENTS = 'create:events',
  UPDATE_EVENTS = 'update:events',
  DELETE_EVENTS = 'delete:events',
  EXPORT_EVENTS = 'export:events',

  // Transporte
  READ_VEHICLES = 'read:vehicles',
  CREATE_VEHICLES = 'create:vehicles',
  UPDATE_VEHICLES = 'update:vehicles',
  DELETE_VEHICLES = 'delete:vehicles',

  READ_DRIVERS = 'read:drivers',
  CREATE_DRIVERS = 'create:drivers',
  UPDATE_DRIVERS = 'update:drivers',
  DELETE_DRIVERS = 'delete:drivers',

  READ_ROUTES = 'read:routes',
  CREATE_ROUTES = 'create:routes',
  UPDATE_ROUTES = 'update:routes',
  DELETE_ROUTES = 'delete:routes',

  READ_TRIPS = 'read:trips',
  CREATE_TRIPS = 'create:trips',
  UPDATE_TRIPS = 'update:trips',
  DELETE_TRIPS = 'delete:trips',

  READ_MAINTENANCES = 'read:maintenances',
  CREATE_MAINTENANCES = 'create:maintenances',
  UPDATE_MAINTENANCES = 'update:maintenances',
  DELETE_MAINTENANCES = 'delete:maintenances',

  // Stock
  READ_PRODUCTS = 'read:products',
  CREATE_PRODUCTS = 'create:products',
  UPDATE_PRODUCTS = 'update:products',
  DELETE_PRODUCTS = 'delete:products',
  EXPORT_PRODUCTS = 'export:products',

  READ_STOCK_MOVEMENTS = 'read:stock-movements',
  CREATE_STOCK_MOVEMENTS = 'create:stock-movements',
  UPDATE_STOCK_MOVEMENTS = 'update:stock-movements',
  DELETE_STOCK_MOVEMENTS = 'delete:stock-movements',

  // Documental e relatorios
  READ_DOCUMENTS = 'read:documents',
  CREATE_DOCUMENTS = 'create:documents',
  UPDATE_DOCUMENTS = 'update:documents',
  DELETE_DOCUMENTS = 'delete:documents',

  READ_REPORTS = 'read:reports',
  EXPORT_REPORTS = 'export:reports',

  // Administracao
  READ_USERS = 'read:users',
  CREATE_USERS = 'create:users',
  UPDATE_USERS = 'update:users',
  DELETE_USERS = 'delete:users',

  READ_ROLES = 'read:roles',
  CREATE_ROLES = 'create:roles',
  UPDATE_ROLES = 'update:roles',
  DELETE_ROLES = 'delete:roles',

  READ_PERMISSIONS = 'read:permissions',
  CREATE_PERMISSIONS = 'create:permissions',
  UPDATE_PERMISSIONS = 'update:permissions',
  DELETE_PERMISSIONS = 'delete:permissions',

  READ_SETTINGS = 'read:settings',
  UPDATE_SETTINGS = 'update:settings',

  READ_AUDIT = 'read:audit',

  // Plataforma (SaaS)
  READ_COMPANIES = 'read:companies',
  CREATE_COMPANIES = 'create:companies',
  UPDATE_COMPANIES = 'update:companies',
  DELETE_COMPANIES = 'delete:companies',
}
